module.exports = __webpack_public_path__ + "public/img/wodeLogo.7dbd61e8.png";